/* ProPlay polish layer: light/dark section rhythm, arrow cleanup, tool-strip tidy. Progressive enhancement only. */
(() => {
  if (window.__ppPolish) return;
  window.__ppPolish = true;

  const DARK = '.pp-room, .pp-gold, .pp-first, .pp-experience';
  const INTERACTIVE = 'form, input, select, textarea, table, [aria-live], [id^="pp-quiz"], .pp-anatomy, script';

  /* 3. Alternate dark sections with cream ones. Sections holding forms, tables or live results stay dark. */
  function rhythm() {
    const sections = [...document.querySelectorAll(`main ${DARK.split(', ').join(', main ')}`)]
      .filter((el) => !el.parentElement.closest(DARK));
    sections.forEach((section, i) => {
      if (i % 2 === 0 || section.classList.contains('pp-light')) return;
      if (section.querySelector(INTERACTIVE)) return;
      section.classList.add('pp-light');
      section.querySelectorAll('[style*="color"]').forEach((el) => el.style.removeProperty('color'));
      if (section.style.color) section.style.removeProperty('color');
      if (section.style.background || section.style.backgroundColor) { section.style.removeProperty('background'); section.style.removeProperty('background-color'); }
    });
  }

  /* 7. Keep the diagonal arrow for links that leave the site; internal links get a plain arrow. */
  const isExternal = (a) => {
    try { const url = new URL(a.getAttribute('href') || '', location.href); return url.host !== location.host && /^https?:$/.test(url.protocol); }
    catch (e) { return false; }
  };
  function arrows(root) {
    root.querySelectorAll('a, button').forEach((el) => {
      if (!el.textContent.includes('\u2197')) return;
      if (el.tagName === 'A' && isExternal(el)) return;
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.includes('\u2197')) node.nodeValue = node.nodeValue.replace(/\u2197/g, '\u2192');
      }
    });
  }

  /* 4. Turn "Link · Link · Link" tool strips into chips by dropping the dot separators. */
  function toolStrips() {
    document.querySelectorAll('.pp-tools-nav p').forEach((p) => {
      [...p.childNodes].forEach((n) => { if (n.nodeType === 3 && /^[\s\u00b7]*$/.test(n.nodeValue)) n.remove(); });
    });
  }

  function run() {
    rhythm();
    toolStrips();
    arrows(document.body);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; arrows(document.body); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();